<template>
  <div class="modal fade" id="BranchSignatoryAddByOneCModel" tabindex="-1" aria-labelledby="BranchSignatoryAddByOneCModelLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!loaded">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="BranchSignatoryAddByOneCModelLabel">
            <span class="text-gray-600">Новый "{{branchSignatoryAddOrUpdateModel.title}}"</span>
          </h5>
          <button @click="clearForm" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <div v-if="error" class="alert alert-dismissible bg-danger d-flex align-items-center flex-column flex-sm-row w-100 p-5 mb-5">
            <i class="ki-duotone ki-notification-bing fs-1 text-light me-4 mb-5 mb-sm-0">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
            <div class="d-flex flex-column text-light pe-0 pe-sm-10">
              <span v-html="error"></span>
            </div>
          </div>
          <template v-if="user">
            <div class="client-card border">
              <div class="client-card__panel">
                <i class="ki-duotone ki-security-user fs-3x text-primary">
                  <i class="path1"></i>
                  <i class="path2"></i>
                </i>
                <div class="ms-4">
                  <div class="fs-6 fw-bolder text-gray-700 line-clamp"
                       data-bs-toggle="tooltip" data-bs-placement="top"
                       :title="user.title">{{ user.title }}</div>
                  <small class="text-gray-500">{{ user.iin  }}</small>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <input-mask-field
                v-model="searchForm.phone"
                id="main.phone.signatory"
                name="main.phone.signatory"
                :disabled="this.searchLoaded"
                :required="true"
                :mb="5"
                placeholder="Номер телефона"
                mask="+7(###) ###-####"
                type="text"
            />
            <input-mask-field
                v-model="searchForm.iin"
                id="main.iin.signatory"
                name="main.iin.signatory"
                :disabled="this.searchLoaded"
                :required="true"
                :mb="5"
                mask="### ### ### ###"
                placeholder="ИИН"
                type="text"
            />
            <button
                v-html="this.searchLoaded ? 'Идет поиск...' : 'Поиск'"
                :disabled="this.searchLoaded || !this.phoneIinValid"
                @click="searchSignatory"
                class="btn btn-sm btn-primary w-100"
                type="submit">
            </button>
          </template>
        </div>
        <div class="modal-footer p-3 justify-content-center">
          <button
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
              v-html="this.user ? 'OK' : 'Закрыть'"
          ></button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="min-height: 319px"/>
      </div>
    </div>
  </div>
</template>

<script>
import InputMaskField       from '@/components/Fields/InputMaskField'
import LoaderFull           from '@/components/Main/LoaderFull'
import axios                from 'axios'

export default {
  name: 'BranchSignatoryAddByOneCModel',
  components: {
    InputMaskField,
    LoaderFull,
  },
  data() {
    return {
      searchLoaded: false,
      loaded:       false,
      searchForm: {
        phone: '+7',
        iin:   '',
      },
      user:   null,
      error:  '',
      phoneIinValid: false
    }
  },
  computed: {
    branchSignatoryAddOrUpdateModel() {
      return this.$store.getters.getBranchSignatoryAddByOneCModel
    }
  },
  methods: {
    searchSignatory() {
      this.searchLoaded = true
      const data = {iin:this.searchForm.iin, phone: this.searchForm.phone}
      axios.post('/api/branches/search-signatory', data)
          .then(res => {
            if (res.data.result) {
              this.user = res.data.data
              this.$store.dispatch('signatoriesRequest')
            } else {
              this.error = res.data.message
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => this.searchLoaded = false)
    },
    clearForm() {
      this.searchForm.phone = '+7'
      this.searchForm.iin   = ''
      this.phoneIinValid    = false
      this.searchLoaded     = false
      this.error            = ''
      this.user             = null
    }
  },
  watch: {
    branchSignatoryAddOrUpdateModel: {
      deep: true,
      handler() {
        this.clearForm()
      }
    },
    searchForm: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.error = ''
        }
        if (this.branchSignatoryAddOrUpdateModel) {
          this.phoneIinValid = newValue.phone.length === 16 && newValue.iin.length === 15
        }
      }
    },
    'searchForm.phone': {
      deep: true,
      handler(newValue) {
        if (newValue.length <= 1) this.form.phone = '7'
      }
    },
    error: {
      deep: true,
      handler(newValue) {
        if (newValue) this.phoneIinValid = false
      }
    }
  }
}
</script>

<style scoped>

</style>